import React, { PropTypes } from 'react';
import classNames from 'classnames';
import './AmountSelector.less';

const AmountSelector = ({value, onIncrease, onDecrease, className}) => {
  return (
    <section className={classNames('amount-selector', className)}>
      <button className="amount-selector-decrease" onClick={onDecrease} />
      <em>{ value ? value : 0 }</em>
      <button className={classNames('amount-selector-increase', {active: !!value})} onClick={onIncrease} />
    </section>
  );
};

AmountSelector.defaultProps = {
  allowDecreaseWhenZero: false
};

AmountSelector.propTypes = {
  value: PropTypes.number.isRequired,
  onIncrease: PropTypes.func,
  onDecrease: PropTypes.func,
  className: PropTypes.string
};

export default AmountSelector;



// WEBPACK FOOTER //
// ./src/components/common/AmountSelector/AmountSelector.js